import React from "react";
import { useNavigate } from "react-router-dom";
import { Calendar, Users, Package, Factory, MapPin, Info } from "lucide-react";
import VisitorStats from "../components/VisitorStats";
import MonthlyVisitorStats from "../components/MonthlyVisitorStats";
import VisitorStatsChart from "../components/VisitorStatsChart";
import "../styles/Dashboard.css";

const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="stats-container">
        <VisitorStats />
        <MonthlyVisitorStats />
      </div>
      <VisitorStatsChart />
      <div className="dashboard-grid">
        <div
          className="dashboard-card"
          onClick={() => navigate("/dashboard/webinars")}
        >
          <Calendar size={24} />
          <h3>Webinar Management</h3>
          <p>Click to manage webinars</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => navigate("/dashboard/partners")}
        >
          <Users size={24} />
          <h3>Partner Management</h3>
          <p>Click to manage partners</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => navigate("/dashboard/products")}
        >
          <Package size={24} />
          <h3>Product Management</h3>
          <p>Click to manage products</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => navigate("/dashboard/industries")}
        >
          <Factory size={24} />
          <h3>Industries Management</h3>
          <p>Click to manage industries</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => navigate("/dashboard/offices")}
        >
          <MapPin size={24} />
          <h3>Regional and Branch Offices</h3>
          <p>Click to manage offices</p>
        </div>
        <div
          className="dashboard-card"
          onClick={() => navigate("/dashboard/about")}
        >
          <Info size={24} />
          <h3>About</h3>
          <p>Click to view about section</p>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
